export const TODO = [
  "Add confietti",
  ":focus pass",
  "Images for the exercise step",
  "Style the Scroll bar",
  "Fix backdrop animation for firefox",
  "Tooltips for settings",
  "Simthsonian api for subjects",
  "Pictures for stretches",
  "Public domain subject prompts",
  "Options to change the timing while in a prompt set",
  "Reference Head Direction Subject",
  "Optimisation Pass",
];
